/* Add address to large columns,recordData||[] Apr 13, 2024 */
/* Add m_exportEmails Sep 21, 2024 */
/* Amend appEntName for Activities tables Feb 22, 2025 */
/* Remove psqft hardcode Apr 11, 2026 */
/* Add reportWidth  Apr 18, 2026 */
/* Add overflow and align for large columns June 13, 2026 */
/* Add 2 checkboxes Chart and Scheduling:Daily or Weekly Oct 31, 2026 */
/* Add StaffingPdf  Oct 31, 2026 */
/* Keep reportCharts menu inside the viewport, borderless with a shadow Oct 22, 2026 */
/* Borderless shadow box on reportColumns Oct 22, 2026 */
/* reportCharts scrolls after 7 rows Oct 22, 2026 */
/* Shorten Break On tags so Chart stays on one line; chart close above header Oct 22, 2026 */
/* Space around the Break On row, and between Break On and Chart Oct 23, 2026 */
/* reportCharts checkbox group stores selected chart values in an array Oct 23, 2026 */
/* Vertically center the reportColumns close with its header Oct 23, 2026 */
/* Keep the reportColumns header and hr fixed; scroll the column list Oct 23, 2026 */
/* Close buttons turn green on hover Oct 24, 2026 */
/* Float reportCharts to the right of Extra Charts/KPI Oct 29, 2026 */
<template lang="pug">
	div(class="kt-reports-opts")
		div(v-show="false")
			<div id="pdfHeader" class="text-start col-sm-6" style="padding-right: 0px">
				<img id="tenantLogo" :src="c_tenantLogoURL" alt="Logo"  class="ms-auto logo me-2"/>
			</div>
		div(class="reports-opts-header") Export and Reports
		div(class="reports-opt-grp")
			<b-button class="btn-link w-100 p-0"  style="borders: 1px;" variant="link"  @click="m_exportExcel" title="Export to Excel" >
				<fa-icon icon="file-excel" style="color: green;"/>Export to Excel
			</b-button>
		<hr style="margin:0em;border-top:0.01em solid #adb5bd;"/>
		div(class="reports-opt-grp")
			<b-button class="btn-link w-100 p-0"  style="borders: 1px;" variant="link"  @click="m_exportPDF" title="Export to PDF" >
				<fa-icon icon="file-pdf" style="color: red;"/>Export to PDF
			</b-button>
		div(v-if="p_tableName=='Opportunities'" class="reports-opt-grp" )
			<b-button class="btn-link w-100 p-0"  style="borders:1px;" variant="link"  @click="m_createReport('opportunitiesByStage')" title="Execute Pdf report" >
				<fa-icon icon="file-pdf" style="color: red;"/>Report:Opportunities By Stage
			</b-button>
		div(v-if="p_tableName=='Contacts'||p_tableName=='Address Book'" class="btn btn-link w-100 p-0 btn-link"  title="Send Email")
			a( :href="c_exportEmails" target="_blank") <fa-icon icon="envelope" style="color: green;"/>Email
		<!--hr style="margin:0em;border-top:0.01em solid #adb5bd;"/-->
		div(v-if="p_tableName=='Staffing'" class="reports-opt-grp" )
			<b-button class="btn-link w-100 p-0"  style="borders:1px;" variant="link"  @click="m_createReport('staffingPdf')" title="Staffing Pdf" >
				<fa-icon icon="file-pdf" style="color: red;"/>Staffing PDF
			</b-button>
		div(v-if="p_tableName=='HomeDashboard'" class="reports-opt-grp" )
			<b-button class="btn-link w-100 p-0"  style="borders:1px;" variant="link"  @click="m_createReport('pipelineChartsReport')" title="Staffing Pdf" >
				<fa-icon icon="file-pdf" style="color: red;"/>Pipeline charts and Report
			</b-button>
			<b-button class="btn-link w-100 p-0"  style="borders:1px;" variant="link"  @click="m_createReport('pipelineKPIsReport')" title="Staffing Pdf" >
				<fa-icon icon="file-pdf" style="color: red;"/>Pipeline KPIs and Report
			</b-button>
		kt-report-list(:key="c_reportListKey" :p_reportContext="d_reportContext" :p_allReports="c_allReports" :p_reportRunning="d_reportRunning" @reportSelected="m_runReport")
		div
			<b-button squared variant="primary"  style="width:100%; text-align:left;" class="btn btn-primary" @click="m_addEditReport">
				<fa-icon icon="pencil-alt" />Add/Edit Report
			</b-button>
			<!-- Modal -->
			b-modal(id="addEditReport" ref="addEditReport" title="Add/Edit Reports" scrollable size="lg" centered header-bg-variant="light" no-fade ok-title="Save" @ok="m_saveReport" @cancel="m_close")
				div(class="addEditReportMain")
					<b-button squared variant="primary" class="btn" @click="m_addNewReport">
						<fa-icon icon="plus" />Add
					</b-button>
					<b-button squared variant="primary"  class="btn" :disabled="!d_allReports.length" @click="m_editReport">
						<fa-icon icon="pencil-alt" />Edit
					</b-button>
					<b-button squared variant="outline-primary"   class="btn" @click="m_previewReport">
						<fa-icon icon="file-pdf" style="color: red;" />Preview
					</b-button>
					hr(class="line")
					<b-form-group :disabled="d_mode==null">
					div(class="form-group")
						span(class="reportLabel") Report Title
						//b-form-select(id="allReports" class="allreports-select" size="md" v-if="d_editReport&&d_allReports.length>0" v-model="d_selectedReportId" :options="c_allReportOptions" @change="m_editSeletedReport" )
						b-dropdown(id="allReports" v-if="d_editReport&&d_allReports.length>0" class="select-drop-down allreports-select" toggle-class="select-drop-down-toggle" menu-class="select-drop-down-menu" variant="link" size="sm" boundary="viewport")
							template(v-slot:button-content) {{ c_selectedReportLabel }}
							b-dropdown-item(v-for="(opt, ix) in c_allReportOptions" :key="ix" :active="d_selectedReportId===opt.value" @click="m_selectReport(opt.value)") {{ opt.text }}
						b-form-input(class="addNewReport" v-if="d_addNewReport" type="text" id="d_newReportName" v-model="d_recData.title" required )
					div(class="form-group")
						label Description
						b-form-textarea(size="sm" id="d_reportDescription" v-model="d_recData.description"  rows="2" )
						div
							label Report Columns
							div(class="col-toggle" style="float:right; ")
								b-dropdown(id="reportColumns" right variant="outline-secondary" toggle-class="btn-menu" menu-class="report-column-menu" title="Setup report columns")
									<span id="reportColumnsClose" @click="m_closeChildWindow" class="topright-close report-column-close" style="font-size:20px;">&times</span>
									span(class="fw-bold text-center d-block px-2 report-column-title") Report Column Useage
									hr(class="my-1")
									div(class="report-column-options")
										draggable(v-model="d_reportColumns" handle=".btn-reorder-cl-item" swapThreshold=.1 animation=150  @end="m_reorderCLItem")
											div(class="dropdown-item" v-for="(col,clix) in d_reportColumns" :key="clix")
												b-button(id="draggBtn" style="border:0;" class="btn-reorder-cl-item" variant="none" )
													<span class="bi-arrow-down-up"></span>
													b-icon(icon="arrow-down-up" class="btn-reorder-columns")
												span {{col.title}}
												b-form-checkbox(v-model="col.visible" v-b-tooltip.hover title="Add/Remove Column")
												b-button(id="sortAsc" style="border:0;" class="btn-sort" variant="none" v-b-tooltip.hover title="Sort Ascending on this column" :disabled="!col.visible" @click="m_sortAsc(col)")
													fa-layers
														fa-icon(icon="arrow-circle-up" class="btn-sort")
														fa-icon(:icon="['fas', 'check']" transform="up-2 right-2" v-show="col.asc")
												b-button(id="sortAsc" style="border:0;" class="btn-sort" variant="none" v-b-tooltip.hover title="Sort Descending on this column" :disabled="!col.visible" @click="m_sortDesc(col)")
													fa-layers
														fa-icon(icon="arrow-circle-down" class="btn-sort")
														fa-icon(:icon="['fas', 'check']" transform="up-2 right-2" v-show="col.desc")
												b-button(id="break" style="border:0;" class="btn-break" variant="none" v-b-tooltip.hover title="Break on this column" :disabled="!col.visible" @click="m_breakColumn(col)")
													fa-layers
														fa-icon(icon="table" class="btn-break")
														fa-icon(:icon="['fas', 'check']" transform="up-2 right-2" v-show="col.break")
												b-button(v-if="col.datatype=='num'" id="totalBtn" style="border:0;" variant="none" class="btn-total" v-b-tooltip.hover title="Calculate Total for this column" :disabled="!col.visible" @click="m_totalColumn(col)")
													fa-layers
														fa-icon(icon="calculator" class="btn-total")
														fa-icon(:icon="['fas', 'check']" transform="up-2 right-2" v-show="col.total")
									template(v-slot:button-content)
										fa-icon(icon="th-list")
						b-form-tags(id="reportColumnsTags" v-model="c_reportColumns" limit=4 size="lg" tag-variant="primary" class="mb-2" add-on-change 
						           remove-on-delete no-outer-focus  style="font-size: 0.8rem;" placeholder="")
						label Sort by
						b-form-tags(size="lg" id="d_reportSort" tag-variant="primary" v-model="c_reportSort" remove-on-delete style="font-size: 0.8rem;" placeholder="")
						div(class="d-flex report-break-row")
							label Break on:
							b-form-tags(size="sm" id="d_reportBreak" tag-variant="primary" v-model="c_reportBreak" remove-on-delete style="font-size: 0.8rem;" placeholder="")
							Label Chart on Break Values:
							b-dropdown(id="chartType-select" class="select-drop-down" dropup toggle-class="select-drop-down-toggle" menu-class="select-drop-down-menu" variant="link" size="sm" boundary="viewport")
								template(v-slot:button-content) {{ c_chartTypeLabel }}
								b-dropdown-item(v-for="opt in d_chartTypes" :key="opt.value" :active="opt.value==-1 ? (d_recData.chartType==null || d_recData.chartType==-1) : d_recData.chartType===opt.value" @click="m_setChartType(opt.value)") {{ opt.text }}
						div(class="d-flex extra-charts-row")
							label Extra Charts/KPI
							div(class="col-toggle")
								b-dropdown(id="reportCharts" ref="reportCharts" right variant="outline-secondary" toggle-class="btn-menu" menu-class="report-chart-menu" boundary="viewport" :popper-opts="d_reportChartPopperOpts" title="Add charts and KPIs" @shown="m_reportChartsShown" @hidden="m_reportChartsHidden")
									<span id="reportChartsClose" @click="m_closeChildWindow" class="topright-close report-chart-close" style="font-size:20px;">&times</span>
									span(class="fw-bold text-center d-block px-2 report-chart-title") Select Charts
									hr(class="my-1")
									div(class="report-chart-options px-2" @click.stop)
										b-form-checkbox-group(v-model="c_reportChartsSelected" :options="c_reportChartOptions" stacked)
									template(v-slot:button-content)
										img(src="@/assets/chartIcon.png" style="width: 25px;")
						b-form-tags(id="reportColumnsTags" v-model="c_reportChartTags" size="lg" tag-variant="primary" class="mb-2" add-on-change  remove-on-delete no-outer-focus  style="font-size: 0.8rem;" placeholder="")
						label Total on
						b-form-tags(size="lg" id="d_reportTotals" tag-variant="primary" v-model="c_reportTotals" remove-on-delete style="font-size: 0.8rem;" placeholder="")
					div(class="form-group" :disabled="d_form_disabled")
						b-link(@click="m_replaceAll" title="Replace Columns, Sort, Totals with current Table" class="blink" :disabled="c_replaceAll") Replace All
						b-form-checkbox(:disabled="!p_filters" id="d_applyFilter"  :value="true" v-model="d_recData.applyFilter") Apply Filter
						div(class="d-flex")
							label Schedule:
							b-dropdown(id="frequency-select" class="select-drop-down" dropup toggle-class="select-drop-down-toggle" menu-class="select-drop-down-menu" variant="link" size="sm" boundary="viewport")
								template(v-slot:button-content) {{ c_frequencyLabel }}
								b-dropdown-item(v-for="opt in d_frequencies" :key="opt.value"  @click="m_setFrequency(opt.value)") {{ opt.text }}
							label Time:
							b-dropdown(id="hour-select" class="select-drop-down" dropup toggle-class="select-drop-down-toggle" menu-class="select-drop-down-menu" variant="link" size="sm" boundary="viewport")
								template(v-slot:button-content) {{ c_hourLabel }}
								b-dropdown-item(v-for="opt in d_hours" :key="opt.value"  @click="m_setHour(opt.value)") {{ opt.text }}
							div(v-if="d_recData.frequency=='weekly'")
								label Week Day:
								b-dropdown(id="weekDay-select" class="select-drop-down" dropup toggle-class="select-drop-down-toggle" menu-class="select-drop-down-menu" variant="link" size="sm" boundary="viewport")
									template(v-slot:button-content) {{ c_weekDayLabel }}
									b-dropdown-item(v-for="opt in d_weekDays" :key="opt.value"  @click="m_setWeekDay(opt.value)") {{ opt.text }}							
						b-form-checkbox(id="d_shared"  :value="true" v-model="d_recData.shared") Shared
						b-form-checkbox(id="d_inactive" :value="true" v-model="d_recData.inactive") Inactive
					</b-form-group>
						

</template>
<script>
import {fn_getTableData,fn_AsyncGET,fn_getAppReports,fn_saveAppReport} from "@/utils/api.js";
import {kbdpAlert} from "@/utils/util.js";
import {refData,fn_appEnt} from "@/utils/ref-data.js";
import {api_baseURL} from "@/utils/init.js";
import XLSX from 'xlsx/xlsx';
import JsPDF from "jspdf";
import 'jspdf-autotable';
import draggable from "vuedraggable";
import {fn_generateReport} from "@/utils/report.js";
import {fn_generateStaffingPdf} from "@/utils/staffingPdf.js";
import KTReportList from '@/components/Ctrl/KT-ReportList.vue';
import {CHART_OPTIONS, fn_normalizeReportCharts} from "@/utils/reportCharts.js";
export default {
	name: "kt-reports",
	components: {draggable,
				"kt-report-list":KTReportList,
				},
	created() {
			this.d_appEnt = fn_appEnt(this.p_appEntKey);
		},
	mounted(){
	
		this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
				this.d_recData={};
				this.d_reportColumns=[];
				this.d_addNewReport=true;
				this.d_editReport=false;
				this.d_mode=null;
		});
	
		
		fn_AsyncGET('appTenantSettings').then((resp) => {
				if (resp.error) {
					let msg = `Unable to read appTenantSetting Error: ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					} else {
							this.d_tenantLogoURL=api_baseURL + resp.general.tenantLogoURL;
							//if(refData.reports) this.d_appReports=refData.reports.filter(r=>r.context==this.p_appEnt);
							this.m_getAppReports();
						}
			});
			

	},
	beforeDestroy(){
		this.m_reportChartsHidden();
	},
	data() {
		return {

			d_appEnt: null,
			d_tenantLogoURL:null,
			d_pdfDoc: null,
			d_today:(new Date()).toLocaleDateString()+' '+(new Date()).toLocaleTimeString(),
			d_pdfTitle:null,
			d_rowcount:3,
			d_requestData:{},
			d_addNewReport:true,
			d_editReport:false,
			d_appReports:[],
			d_allColumns:[],
			d_reportTitle:null,
			d_reportColumns:[],
			d_reportSort:[],
			d_reportBreak:[],
			d_reportTotals:[],
			d_recData:{},
			d_reportContext:null,
			d_selectedReport:null,
			d_reportListKey:1,
			d_reportRunning:false,
			d_allReports:[],
			d_selectedReportId:null,
			d_mode:null,
			d_refData:null,
			d_activeFilter:null,
			d_reportData:[],
			d_reportChartPopperOpts:{
				positionFixed:true,
				modifiers:{
					viewportFit:{
						enabled:true,
						order:840,
						fn:function(data){
							var margin=8;
							var pop=data.offsets.popper;
							var vw=document.documentElement.clientWidth||window.innerWidth;
							var vh=document.documentElement.clientHeight||window.innerHeight;
							if(pop.left<margin) pop.left=margin;
							if(pop.left+pop.width>vw-margin) pop.left=Math.max(margin, vw-margin-pop.width);
							if(pop.top<margin) pop.top=margin;
							if(pop.top+pop.height>vh-margin) pop.top=Math.max(margin, vh-margin-pop.height);
							return data;
						}
					}
				}
			},
			d_chartTypes:[
			    {value:-1,text:"\u00A0"},
				{value:'pie', text:'Pie'},
				{value:'doughnut', text:'Doughnut'},
				{value:'bar', text:'Bar'}
			],
			d_frequencies:[
			    {value:-1,text:" "},
				{value:'daily', text:'Daily'},
				{value:'weekly', text:'Weekly'}
			],
			d_weekDays: [
				{ value: "mon", text: "Monday" },
				{ value: "tue", text: "Tuesday" },
				{ value: "wed", text: "Wednesday" },
				{ value: "thu", text: "Thursday" },
				{ value: "fri", text: "Friday" }
				],
			d_hours: [
					{ value: "8", text: "8 AM" },
					{ value: "9", text: "9 AM" },
					{ value: "10", text: "10 AM" },
					{ value: "11", text: "11 AM" },
					{ value: "12", text: "12 Noon" },
					{ value: "13", text: "1 PM" },
					{ value: "14", text: "2 PM" },
					{ value: "15", text: "3 PM" },
					{ value: "16", text: "4 PM" },
					{ value: "17", text: "5 PM" },
					{ value: "18", text: "6 PM" }
				],
		};
	},
	props: {
		p_appEntKey: String,
		p_tableName:String,
		p_cols:Array,
		p_tableData:Object,
		p_refData:Object,
		p_sort:Array,
		p_filters:Object,
		p_ganttBars:Object,
		p_chartStartDate:String,
		p_chartEndDate:String,
	    p_viewMode:String,		
	},
	computed: {
			c_hourLabel() {
				const sel = this.d_recData.hour;
				const opt = this.d_hours.find(o => o.value === sel);
			return opt ? opt.text : "8AM";
			},
			c_weekDayLabel() {
				const sel = this.d_recData.weekDay;
				const opt = this.d_weekDays.find(o => o.value === sel);
			return opt ? opt.text : "Monday";
			},	
			c_chartTypeLabel(){
				var value=this.d_recData.chartType;
				var match=this.d_chartTypes.filter(function(o){ return o.value===value; })[0];
				return match ? match.text:"\u00A0";
			},
			c_frequencyLabel(){
				var value=this.d_recData.frequency;
				var match=this.d_frequencies.filter(function(o){ return o.value===value; })[0];
				return match ? match.text:" ";
			},
			c_reportListKey(){return this.d_reportListKey;},
			c_allReports(){return this.d_allReports;},
			c_appEntName(){ return this.p_tableName.includes('Activities')?this.p_tableName:this.d_appEnt.label;},
			c_tenantLogoURL() {	return this.d_tenantLogoURL;},
			c_reportColumns:{  get() {
										return this.d_reportColumns.filter(c=>c.visible).map(c=>{return c.title;});
								},
								set(value){
									this.d_reportColumns.forEach(c=>{c.visible=value.includes(c.title);});
								}
								
			},
			c_reportTotals:{ get(){
									return this.d_reportColumns.filter(c=>c.visible&&c.total).map(c=>{return c.title;});
							},
							set(value){
								this.d_reportColumns.forEach(c=>{c.total=value.includes(c.title);});
								}
				},
			c_reportBreak:{	get(){
									return this.d_reportColumns.filter(c=>c.visible&&c.break).map(c=>{return c.title;});
									},
							set(value){
									this.d_reportColumns.forEach(c=>{c.break=value.includes(c.title);});	
									}				
				},
			c_availableColumns(){var v_columns=this.d_allColumns.filter(c => this.d_reportColumns.indexOf(c) === -1);
								v_columns.sort((a,b)=>{return (a > b) ? 1 : -1;});
								return v_columns;
			},
			c_applyFilter(){return this.p_filterData;},
			c_reportSort: { get(){ 
									return this.d_reportColumns.filter(c=>c.visible&&(c.asc||c.desc))
											.map(x =>{return x.title + (x.asc?" ↑":x.desc?" ↓":'');});
							},
							set(value){

										this.d_reportColumns.forEach(c=>{
																		c.asc=value.includes(c.title+" ↑");
																		c.desc=value.includes(c.title+" ↓");
																		});
										}
			},
			c_label() {
					return this.d_recData.title;
				},
			c_allReportOptions(){ return [{value: null, text: 'Please select a report'},
											...this.d_allReports.map(r=>{return {text:r.title,value:r.reportId};})
										];
			},
			c_replaceAll(){return !(this.d_selectedReportId);},
			c_form_disabled(){return this.d_form_disabled;},
			c_exportEmails()
			{
				var emailAddresses=null;
				this.p_tableData.filter(d=>d.email)
				.map(e=>{return e.email.trim()})
				.forEach(e=>{emailAddresses=emailAddresses?emailAddresses+","+e:e;});
				console.log('emailAddresses');
				console.log(emailAddresses);
				return "mailto:"+emailAddresses;
			},
			c_allReportOptions(){ return [{value: null, text: 'Please select a report'},
										...this.d_allReports.map(r=>{return {text:r.title,value:r.reportId};})
										];
			},
			c_selectedReportLabel(){
				var value=this.d_selectedReportId;
				var match=this.c_allReportOptions.filter(function(o){ return o.value===value; })[0];
				return match ? match.text : 'Please select a report';
			},
			c_reportChartOptions(){ return CHART_OPTIONS; },
			c_reportChartsSelected:{
				get(){
					var charts = this.d_recData && this.d_recData.reportCharts;
					if(Array.isArray(charts)) return charts;
					return fn_normalizeReportCharts(charts, this.d_recData && this.d_recData.reportChart);
				},
				set(value){
					this.$set(this.d_recData, 'reportCharts', Array.isArray(value) ? value : []);
				}
			},
			c_reportChartTags:{
				get(){
					var selected = this.c_reportChartsSelected;
					return CHART_OPTIONS.filter(o => selected.includes(o.value)).map(o => o.text);
				},
				set(value){
					var texts = value || [];
					var keys = CHART_OPTIONS.filter(o => texts.includes(o.text)).map(o => o.value);
					this.$set(this.d_recData, 'reportCharts', keys);
				}
			},
	},
	methods: {
		m_selectReport(value){
			this.d_selectedReportId=value;
			this.m_editSeletedReport();
		},	
		m_reportChartsShown(){
			var modal=document.getElementById('addEditReport');
			var nodes=modal?[modal.querySelector('.modal-content'), modal.querySelector('.modal-body')]:[];
			this._reportChartOverflow=[];
			nodes.forEach(el=>{
				if(!el) return;
				this._reportChartOverflow.push({el:el, overflow:el.style.overflow});
				el.style.overflow='visible';
			});
			this.$nextTick(()=>{
				if(this.$refs.reportCharts && this.$refs.reportCharts.updatePopper)
					this.$refs.reportCharts.updatePopper();
			});
		},
		m_reportChartsHidden(){
			(this._reportChartOverflow||[]).forEach(item=>{
				item.el.style.overflow=item.overflow||'';
			});
			this._reportChartOverflow=[];
		},
		m_closeChildWindow(){
			var editEl=document.getElementById("d_reportTitle");
			var addEl=document.getElementById("d_newReportName");
			if(this.d_addNewReport) addEl.focus(); else editEl.focus();
		},
		m_replaceAll(){
			this.d_recData.reportColumns=this.p_cols;
			this.d_recData.reportSort=this.p_sort;
			this.d_recData.filter=this.p_filters;
		},
		m_getAppReports(){
		fn_getAppReports({context:this.p_tableName.toLowerCase()}).then(resp => {

				if (resp.error ) {
					let msg = `Unable to  get Report records ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					return;
				
				} else {if(resp.recordData||[].length>0) this.d_allReports=[...resp.recordData];}

			});
		},
		m_applyFilter(data,filters){
		return data.filter(row => {
				for (const key in filters) {
					if (filters[key]?.range &&
						!(filters[key]?.min <= row[key] && row[key] <=filters[key]?.max)
					) {	return false;}	
					if (filters[key]?.date &&
						!((new Date(row[key])) >= (new Date(filters[key].min)) &&
						(new Date(row[key])) <= (new Date(filters[key].max)))
					) {return false;}
					if (filters[key]?.length && 
						!~filters[key].indexOf(row[key])
					) {return false;}
				}
				return true;
			});	
		},
		m_saveReport(){
		

			
			this.d_recData["context"]=this.p_tableName.toLowerCase();
			this.d_recData["reportName"]=(this.d_recData.title.substr(0,50)).replace(/\s/g, '');
			this.d_recData["reportColumns"]=this.d_reportColumns;
			this.d_recData["tableName"]=this.p_tableName;
			if(this.d_recData.applyFilter) this.d_recData["reportFilter"]=this.p_filters;	
			var filters=this.p_filters;
			var reportColumns=this.d_reportColumns;
			var reportTitle=this.d_recData.title;
			var recData=this.d_recData;
			kbdpAlert.showSaving(reportTitle);
			
			var params={reportId:this.d_recData.reportId,recordData:JSON.stringify(this.d_recData)};
			

			

			fn_saveAppReport(params).then(resp => {
			



				if (resp.error || !resp.upsRecHdr) {
					let msg = `Unable to save ${reportTitle}: ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					return;
				}
				let upsRec = resp.upsRecHdr;

				if (recData.reportId) {
					//Edited Existing
					this.d_recData=recData;
					this.d_recData.updatedById = upsRec.updatedById;
					this.d_recData.updatedUTC = upsRec.updatedUTC;
					this.d_reportListKey++;
				} else {
					//Added New
					this.d_recData=recData;
					this.d_recData["reportId"] = upsRec.reportId;
					this.d_recData["createdById"] = upsRec.createdById;
					this.d_recData["createdUTC"] = upsRec.createdUTC;
					this.d_allReports.push(this.d_recData);
					this.d_reportListKey++;
				}
				kbdpAlert.showOk(reportTitle + " was saved successfully.");
				
				
			});
		},
		m_close(){this.d_addEditReport=false;},
		m_clickSort(sort){},
		m_addEditReport(){this.$bvModal.show("addEditReport");},
		m_addNewReport(){ 	
		
							this.d_mode='Add';
							this.d_addNewReport=true;
							this.d_editReport=false;
							this.d_recData={reportCharts:[]};
							this.d_allColumns=this.p_cols.map(c=>{return c.title});
							this.d_reportColumns=this.p_cols.map(c=>{
												var v_asc=null;
												var v_desc=null;
												var sortColumn=this.p_sort?.filter(s=>s.col==c.field)[0];
												if(sortColumn){
																v_asc=sortColumn.dir=='asc';
																v_desc=sortColumn.dir=='desc';
																}
												return {field:c.field,title:c.title,visible:c.visible,datatype:c.datatype,
												asc:v_asc,desc:v_desc,total:c.datatype=='num'?true:null,break:null};
												});
							this.d_reportData.reportFilter=this.p_filterData;
							if(this.p_filters) this.d_reportData.applyFilter=true;

						},
		m_editReport(){ 	this.d_addNewReport=false;
							this.d_editReport=true;
							this.d_mode='Edit';
							this.d_recData={};
							this.d_reportColumns=[];
							this.d_selectedReportId=null;
						},
		m_editSeletedReport(){	if(this.d_selectedReportId){
								this.d_recData=this.d_allReports.filter(r=>r.reportId==this.d_selectedReportId)[0];
								this.d_reportTitle=this.d_recData.title;
								this.d_reportColumns=this.d_recData.reportColumns;
								this.$set(this.d_recData, 'reportCharts', fn_normalizeReportCharts(this.d_recData.reportCharts, this.d_recData.reportChart));
								} else {this.d_recData=[];
										this.d_reportColumns=[];
										}
							},
		m_previewReport(){
						
						var reportData={};
						reportData["reportTitle"]=this.d_recData.title;
						reportData["reportColumns"]=this.d_reportColumns.filter(c=>c.visible).map(c=>c.field);
						reportData["reportBreak"]=this.d_reportColumns.filter(c=>c.visible&&c.break)[0]?.field;
						reportData["allColumns"]=this.p_cols;
						reportData["reportData"]=[...this.p_tableData];
						reportData["reportTotals"]=this.d_reportColumns.filter(c=>c.visible&&c.total).map(c=>{return c.field;});
						reportData["reportType"]='pdf';
						reportData["chartType"]=this.d_recData.chartType;
						reportData["reportCharts"]=this.d_recData.reportCharts;
						reportData["tableName"]=this.p_tableName;
						fn_generateReport(reportData);
					},
		m_runReport(selectedReport){
		
		console.log('selectedReport');
		console.log(selectedReport);
		if(!selectedReport||!selectedReport.reportColumns) return;
		this.d_reportRunning=true;
		
		//var selectedReport=this.d_allReports.filter(r=>r.reportId==selectedReport.reportId)[0]
		var reportColumns=selectedReport.reportColumns;
		var activeFilters=selectedReport.reportFilter;
		var reportTitle=selectedReport.title;
		
	
		
		var order=reportColumns.filter(c=>c.visible&&(c.asc||c.desc))
				.map(c =>{return c.asc?c.field+' ASC':c.field+' DESC';});

		let reqPrms = {order:order.join(),limit:255};
		let appEntName = this.d_appEnt.label.toLowerCase().replace(" ", "");
		if(this.p_tableName.includes('Activities')) appEntName=this.d_appEnt.name+'Tasks';
		fn_getTableData(appEntName, reqPrms).then(resp => {
		
		if (resp.error ) {
				let msg = `Unable to get data for Report ${reportTitle} ` + (resp.error || "");
				kbdpAlert.showErr(msg);
				return;
			} else { if(resp.rows.length>0){
			
						//var refData = resp.refData;
						var reportData = [...resp.rows];
						
						// Add customData
						reportData.forEach(r=>{
							var customData=r.customData;
							if(customData){
									Object.keys(customData).forEach(cf=>{
									r[cf]=customData[cf];
							});
							}
						});
						
						// Apply filter 
						reportData = this.m_applyFilter(reportData,activeFilters);
						
						var repData={};
						repData["reportTitle"]=reportTitle;
						repData["reportColumns"]=reportColumns.filter(c=>c.visible).map(c=>c.field);
						repData["allColumns"]=this.p_cols;
						repData["reportData"]=[...reportData];
						repData["reportTotals"]=reportColumns.filter(c=>c.visible&&c.total).map(c=>{return c.field;});
						repData["reportBreak"]=reportColumns.filter(c=>c.visible&&c.break)[0]?.field;
						repData["reportType"]='pdf';
						repData["chartType"]=selectedReport.chartType;					
						repData["reportCharts"]=this.d_recData.reportCharts;
						repData["tableName"]=selectedReport.tableName;
						fn_generateReport(repData);
						this.d_reportRunning=false;

					
					
				} else kbdpAlert.showErr("No Data Found for "+ reportTitle);
				
				}
				
			}).catch(() => {
				kbdpAlert.showErr("Unable to get data for Report " + reportTitle);
			}).then(() => {
				this.d_reportRunning=false;
			});
		
		},
		m_addCustomData(){

		},
		m_sortAsc(col){
						this.d_reportColumns.forEach(c=>{
						if(c.field==col.field){
								c.asc=!c.asc;
								if(c.asc) c.desc=false;

							}
						});
										
		},
		m_sortDesc(col){
						this.d_reportColumns.forEach(c=>{
						if(c.field==col.field){
								c.desc=!c.desc;
								if(c.desc) c.asc=false;
							}
						});

		},
		m_setChartType(value){
			// Blank menu item is -1; store null so the report appends no chart
			this.$set(this.d_recData,'chartType', value==-1 || value==null || value==='' ? null : value);
		},
		m_setFrequency(value){
			this.$set(this.d_recData,'frequency',value);
		},
		m_setHour(value){
			this.$set(this.d_recData,'hour',value);
		},
		m_setWeekDay(value){
			this.$set(this.d_recData,'weekDay',value);
		},
		m_breakColumn(col){
			this.d_reportColumns.forEach(c=>{
						if(c.field==col.field) {
							c.break=!c.break;
							if(c.break) this.d_reportBreak.push(c.title);
						}else{if(c.break) c.break=!c.break;}
						});
		},
		m_totalColumn(col){
						this.d_reportColumns.forEach(c=>{
						if(c.field==col.field)c.total=!c.total;	
						});
		},
		m_deleteColumns(){this.d_reportData.reportColumns=this.p_cols.map(c=>{return c.title});},
		m_pdfReport() {},
		m_exportPDF(e) {
						var pdfExport={ reportTitle:this.p_tableName,
										reportColumns:this.p_cols.filter(c => c.visible).map(c=>c.field),
										allColumns:this.p_cols,
										reportData:[...this.p_tableData],
										reportTotals:this.p_cols.filter(pc => pc.visible&&pc.datatype=="num").map(c=>c.field),
										reportType:'pdf',
										includeChart:this.d_recData.includeChart,
										chartType:this.d_recData.chartType,
										tableName:this.p_tableName,
										};
						fn_generateReport(pdfExport);
		},
		m_exportExcel(e) {
		
			var excelExport={reportTitle:this.p_tableName, 
							reportColumns:this.p_cols.filter(c => c.visible).map(c=>c.field),
							allColumns:this.p_cols,
							reportData:[...this.p_tableData],
							reportType:'excel'
						};
			fn_generateReport(excelExport);
				
	},
	m_createReport(ReportName){
	var pdfReport;
	
	switch(ReportName) {
	            case 'staffingPdf': {
				
					pdfReport={reportTitle:this.p_viewMode,
					              reportColumns:this.p_cols,
				                  reportData:Array.isArray(this.p_tableData) ? this.p_tableData : [],
								  allColumns:this.p_cols,
								  ganttBars:this.p_ganttBars,
								  chartStartDate:this.p_chartStartDate,
								  chartEndDate:this.p_chartEndDate,
								  viewMode:this.p_viewMode,
								  tableName:this.p_tableName,
								};
				fn_generateReport(pdfReport)
				}
				break;
				case 'pipelineChartsReport' :{
				
					pdfReport={reportTitle:"Pipeline Summary charts",
					              reportColumns:this.p_cols,
				                  reportData:Array.isArray(this.p_tableData) ? this.p_tableData : [],
								  allColumns:this.p_cols,
								  reportType:'pdf',
                                  reportCharts:["statusChart","marketSegmentChart","categoryChart"],
								  tableName:this.p_tableName,
								};
				fn_generateReport(pdfReport)
				
				}
				break;
				case 'pipelineKPIsReport' :{
						pdfReport={reportTitle:"Pipeline Summary KPIs",
					              reportColumns:this.p_cols,
				                  reportData:Array.isArray(this.p_tableData) ? this.p_tableData : [],
								  allColumns:this.p_cols,
								  reportType:'pdf',
                                  reportCharts:["totalPipelineValueKPI","wonThisQuarterKPI","dueThisMonthKPI","hitRateKPI"],
								  tableName:this.p_tableName,
								};
				fn_generateReport(pdfReport)			
				}
				break;
				case 'opportunitiesByStage': {
				/*
				var columnWidth={};
				//var largeCololumns=['opportunityName','clientAccountId','streetAddress','projectName','address'];
				this.p_cols.forEach(c=>{
					columnWidth[c.field]=c.reportWidth?{cellWidth: c.reportWidth,overflow: 'linebreak', valign: 'top'}:{cellWidth: 200}
				
										});
				var columns=this.p_cols.filter(x => x.visible&&x.field!=="opportunityTypeId");

				var tableColumns=columns.map(x => {
						return {dataKey:x.field};
					});
				var columnStyles={};
				var reportWidth=0;
				columns.forEach((c,i) => {
					reportWidth += parseInt(columnWidth[c.field].cellWidth);

					columnStyles[i] = {
									valign: 'top',
									cellWidth: parseInt(columnWidth[c.field].cellWidth)
									};					});
				
				var format=reportWidth>750?"a3":"a4";
				const columnHeaders=columns.map((column) => column.title);
				
				const date = new Date();
		
				
				this.m_createPdf("Opportunities By Stage", format,reportWidth);
				


				let exportData = this.p_tableData.map(a => {
				let newObject = {};
					Object.keys(a).forEach(propertyKey => {
							newObject[propertyKey] = a[propertyKey];
					});
				return newObject;
				});
			
				var pdfRecord=[];
				var pdfData=[];
				
				
				var opportunityStages=refData.opportunityTypes.map(t=>{return t.name});
					
			
				opportunityStages.forEach(s=>{
				
				var totals=[];
				totals.length=0;
				pdfRecord.length=0;
				pdfData.length=0;
				
				var getStage=this.p_cols.filter(x => x.field=="opportunityTypeId")[0].valFmtFn
					
				var heading="Stage:"+s;
			
				exportData.filter(d=>getStage(d.opportunityTypeId)==s).forEach(rec =>{
								columns.forEach((col,idx) => {
								var val=rec[col.field];
								var dVal=col.valFmtFn?col.valFmtFn(val):val;
								pdfRecord.push(dVal?dVal:null);
								if(col.showAggr=='sum') totals[idx]=totals[idx]?totals[idx]+(val?val:0):(val?val:0)
								else totals[idx]="";
								});
						pdfData.push(pdfRecord);
						pdfRecord=[];
				});
				
				if(pdfData.length>0) {
							totals[0]="Totals:"+pdfData.length;
							var tTotals=totals.map((t,idx)=> {return columns[idx].valFmtFn?columns[idx].valFmtFn(t):t;});
							this.m_pdfAppendTable(heading,columnHeaders,tableColumns,columnStyles,pdfData,tTotals);
							}
			
			});


			
			window.open(URL.createObjectURL(this.d_pdfDoc.output("blob")));
			*/
			
			    var columns=this.p_cols.filter(x => x.visible&&x.field!=="opportunityTypeId")
				      .map(x => {return x.field;});
				
				console.log('columns:',columns);
					
				pdfReport={reportTitle:"Opportunity By Stage",
								reportColumns:columns,
								reportData:Array.isArray(this.p_tableData) ? this.p_tableData : [],
								allColumns:this.p_cols,
								reportType:'pdf',
								reportBreak:"opportunityTypeId",
								reportTotals:["value"],
								chartType:"doughnut",
								tableName:this.p_tableName,
							};
				fn_generateReport(pdfReport)
			
			}
			break;	
			default:
				// code block
		}	
	},
	m_createPdf(title,format,reportWidth){
		
 
		
		var lWidth=1.09*reportWidth
		this.d_pdfDoc = new JsPDF({orientation: 'l',  unit: 'pt', format:[lWidth, 841.89]});  // landscape
		this.d_pdfDoc.setFontSize(11);
		this.d_pdfDoc.setTextColor(30,144,255);
		
	
		
		var tenantLogo = document.getElementById("tenantLogo");
		this.d_pdfDoc.addImage(tenantLogo,15,15,30,30);

		if(title) this.d_pdfDoc.text(title,(reportWidth-title.length)/2,40);
		this.d_pdfDoc.text(`Date:${this.d_today}`,reportWidth-100,40);
	
	},
	m_pdfAppendTable(heading,columnHeaders,tableColumns,columnStyles,data,totals){ 
	
	
		//var rowCount=data.length;
		var startY=this.d_pdfDoc.lastAutoTable.finalY||50;
		var headingY=startY+20;
		var tableY=startY+30;
		this.d_pdfDoc.setTextColor(65,105,225);
		
		
		if(heading) this.d_pdfDoc.text(heading,20,headingY);
		this.d_pdfDoc.autoTable({
				head: [columnHeaders],
				body: data,
				foot:totals.length?[totals]:[],
				footStyles:{textColor:[0,0,0],fillColor:[255, 255, 255]},
				startY: tableY,
				styles: {
						overflow: 'linebreak',
						cellWidth: 'wrap',
						minCellHeight: 9,
						halign: 'left',
						fontSize: 11,
						},
				columnStyles,
				pageBreak:'auto',
				showHead: 'firstPage',
				showFoot: 'lastPage',
				columns:tableColumns,
				});
	},
     m_scheduleChange() {
	      this.d_schedule = !this.d_schedule;
		  if(!this.d_schedule) {
		  this.d_recData.freqency=null;
		  this.d_recData.hour=null;
		  this.d_recData.weekDay=null;
		  
		  }
     },	 
	},
	watch:{}
	
};
</script>

<style lang="less">
div.kt-reports-opts {
	width: 240px;
	border: none;
	border-radius: 6px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
	div.reports-opts-header {
		padding: 0.2em 0.4em;
		background-color: #6c757d;
		color: #fff;
		margin-bottom: 0.0em;
		border: none;
	}
}
.reports-opt-grp {
		//padding: 0 0.5em 0.2em 0.5em;
		margin: 0em;
		display: flex;
		flex-wrap: wrap;
		background-color: white;
		width: 100%;
		font-size: 0.9em;
		line-height: 1.1em;
		color: #4fa4ff;
		padding: 0 0.0em;
}
.btn-link {
	display:inline-block;
	//width: 100%;
	padding-bottom: 0.5em;
	text-align: left;
	}
.btn-100{
     width: 100%;
    }
.btn-pdf,
.btn-excel
 {
			font-size: 0.8em;
			width: 23px;
			padding: 0.1em 0em;
			margin: 0.25em 0;
			margin-left: 0.5em;
}
.logo {
		height:50px;
		width:50px;
		float: left;
	}
.moneycolor{color:blue;}
.textleft{	text-align: left;}
.fw-bold{font-weight: bold;}
.ta-end{text-align: end;}
.ta-start{text-align: start;}
.selectinput {
			width:100%;
			margin-right: 0.3em;
			opacity: 0.5;
			border:none;
			color:#007bff;
			&:hover {
			opacity: unset;
				}
			}
.selectinput{
  content: "↓";
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border-width: 1px;
  border-style: inherit;
  border-color: inherit;
  border-radius: inherit;
}
.selectinput:hover::after {
  background-color: #007bff;
}
.optioninput{
			border:none;
			color:#007bff;
		}
.modalPage{ width: 200px;
			float:right;
			}
div.form-group {
		min-width: 300px;
		//display: flex;
		flex-wrap: wrap;
		> label {
			min-width: 130px;
			margin: auto 0;
		}
     }
.input-value {
			margin-right: 0.8em;
			opacity: 0.5;
			&:hover {
			opacity: unset;
				}
			}
.reportLabel{margin-right: 0.2em;}
.reportLabel2{margin-left: 1.0em;}
.btn {margin-right: 0.3em;}
.line{border:none;
   margin-top:0.1em;
   margine-bottom:0.1em;
}
.addEditReportMain{
		height:600px;
}
.col-toggle {
	ul.dropdown-menu {
		padding: 0.5em 0;
		max-height: 250px;
		min-width: 150px;
		overflow-y: auto;
		}
	ul.dropdown-menu.report-chart-menu,
	ul.dropdown-menu.report-column-menu {
		border: none;
		border-radius: 0.25rem;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
		background: #fff;
		z-index: 2000;
		overflow-x: hidden;
		overflow-y: hidden;
		max-height: calc(100vh - 16px);
		padding: 0.35rem 0 0.5rem;
		}
	ul.dropdown-menu.report-chart-menu {
		min-width: 220px;
		}
	.report-column-menu .report-column-options {
		max-height: 220px;
		overflow-x: hidden;
		overflow-y: auto;
		}
	.report-chart-menu .report-chart-options .custom-control {
		min-height: 1.5rem;
		margin-bottom: 0;
		}
	.report-chart-menu .report-chart-options {
		max-height: calc(7 * 1.5rem);
		overflow-x: hidden;
		overflow-y: auto;
		}
	.report-chart-menu .report-chart-close,
	.report-column-menu .report-column-close {
		float: right;
		cursor: pointer;
		line-height: 1;
		margin: 0 0.45rem 0.15rem 0;
		position: relative;
		z-index: 2;
		&:hover {
			color: green;
			}
		}
	#reportColumnsClose {
		position: relative;
		top: -0.45rem;
		}
	.report-chart-menu .report-chart-title {
		clear1: both;
		}
	}
.extra-charts-row {
	align-items: center;
	width: 100%;
	> label {
		margin-bottom: 0;
		}
	> .col-toggle {
		margin-left: auto;
		margin-right: 20px;
		}
	}
.report-break-row {
	align-items: center;
	flex-wrap: nowrap;
	margin-top: 0.75rem;
	margin-bottom: 0.75rem;
	> label {
		flex: 0 0 auto;
		white-space: nowrap;
		margin-bottom: 0;
		}
	#d_reportBreak {
		flex: 0 1 40%;
		width: 40%;
		max-width: 40%;
		min-width: 6rem;
		margin-right: 1rem;
		}
	> .select-drop-down {
		flex: 0 0 auto;
		}
	}
.dropdown-item {
				padding: 0.2em 0.75em;
				display: flex;
				}
.btn-reorder-columns {
	cursor: move;
	padding: 0;
}
.sort-by{
					&.asc::after {
						content: " ↑";
						color: #4fa4ff;
					}
					&.desc::after {
						content: " ↓";
						color: #4fa4ff;
					}
}
.btn-sort{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
	}
.btn-total{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
		}
.btn-break{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
		}
svg.fa-check {
				font-size: 0.8em;
				color: #28a745;   //#dc3545;
				&:hover {
					opacity: 0.8;
						}
	}
.modalDiv{max-width:700px;}	
.btn-menu{border:none;}
a.disabled {
	color:grey;
	pointer-events: none;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.close,
.topright-close {
  color: red;
  font-size: 20px;
}
.close:hover{color:green;}
.col-toggle .topright-close:hover {color: green;}
/* The option list of a native select cannot be styled. This menu is both boxes. */
.select-drop-down {
	margin-left: 0.75rem;
}
.select-drop-down > .select-drop-down-toggle.btn {
	//width: 200px;
	text-align: left;
	color: #212529;
	background-color: #fff;
	border: none;
	border-radius: 0.25rem;
	//box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
	font-size: 0.875rem;
	padding: 0.25rem 1.75rem 0.25rem 0.75rem;
	text-decoration: none;
}
.select-drop-down > .select-drop-down-toggle.btn:hover,
.select-drop-down > .select-drop-down-toggle.btn:focus,
.select-drop-down.show > .select-drop-down-toggle.btn {
	color: #212529;
	background-color: #fff;
	border: none;
	text-decoration: none;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
}
.select-drop-down > .select-drop-down-toggle.dropdown-toggle::after {
	position: absolute;
	right: 0.75rem;
	top: 50%;
	margin-top: -1px;
}
.select-drop-down .dropdown-menu.select-drop-down-menu {
	border: none;
	border-radius: 0.25rem;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
	//min-width: 200px;
	//width: 200px;
	padding: 0.35rem 0;
	margin-top: 4px;
}
.select-drop-down .dropdown-item {
	font-size: 0.875rem;
	color: #212529;
}
.select-drop-down .dropdown-item:hover,
.select-drop-down .dropdown-item:focus {
	background-color: #f4f6f8;
	color: #212529;
}
.select-drop-down .dropdown-item.active,
.select-drop-down .dropdown-item:active {
	background-color: #e7f1ff;
	color: #212529;
}
/* Applies to b-form-select and most custom selects */
.allreports-select {
  max-height: 150px;     /* ~5 rows */
  overflow-y: auto;
}
.select-drop-down .scroll-select {
  max-height: 150px;     /* ~5 rows */
  overflow-y: auto;
}
/* For dropdown menus (b-dropdown, kt-select, etc.) */
.select-drop-down .dropdown-menu {
  max-height: 150px !important;
  overflow-y: auto !important;
}

</style>
